import { useLocation } from "react-router"
import { useParams } from "../../../../../../../../router"
import { Breadcrumbs, searchToQuery } from "@sembark-travel/ui/router"
import { generatePath } from "../../../../../../../../router-utils"
import { CompareCabMetricsPricesSheet } from "../../../../../../../../DataDrive/Metric"
import { Helmet } from "react-helmet-async"

export default function MetricsVersionComparePage() {
	const location = useLocation()
	const { folderId, fileId, versionId1, versionId2 } = useParams(
		"/data-drive/folders/:folderId/files/:fileId/compare/:versionId1/:versionId2/metric"
	)
	const query = searchToQuery<{
		file: string
		folder: string
	}>(location && location.search)

	const fileName = query["file"] || ""

	const folderName = query["folder"] || ""

	return (
		<>
			<Helmet>
				<title>Comparison of Metric Sheets</title>
			</Helmet>
			<Breadcrumbs
				key={"Metric Sheet Prices Compare"}
				title="Metric Sheet Prices Compare"
				items={[
					[
						generatePath("/data-drive/folders/:folderId/files/:fileId", {
							folderId,
							fileId,
						}),
						`${folderName || ""}`,
					],
					[
						generatePath(
							"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view",
							{ folderId, fileId, versionId: versionId1 }
						),
						`${fileName || ""}`,
					],
				]}
			/>
			<CompareCabMetricsPricesSheet
				metricSheetId={fileId}
				metricSheetVersionId1={versionId1}
				metricSheetVersionId2={versionId2}
			/>
		</>
	)
}
